import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "reactstrap";
import { decreaseQuantity, increaseQuantity } from "store/actions/cartAction";
import { FaMinus, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { checkFinalPrice } from "../checkFinalPrice";

const ItemCounter = ({ orderItem }) => {
  const dispatch = useDispatch();
    const { orderItems } = useSelector((state) => state.cart);
    const { restaurantsDetail } = useSelector((state) => state.restaurant);
    const bgColor = restaurantsDetail?.adminColor;

  
    const itemPrice = parseFloat(orderItem?.price) || 0;
  
    const simulatedFinal = checkFinalPrice({
      cartItems: orderItems,
      restaurant: restaurantsDetail,
      itemPrice: itemPrice,
    });
    const isDisabled = simulatedFinal >= 10000;
  
    const handleIncrement = (id, size) => {
      if (isDisabled) {
        return;
      }

      const simulatedValue = checkFinalPrice({   //To show the toast in advance that no more quantity update is possible after this increment
        cartItems: orderItems,
        restaurant: restaurantsDetail,
        itemPrice: itemPrice * 2,
      });
  
      if (simulatedValue >= 10000) {
        toast.warning("Total amount limit per order is 10,000.");
      }
      
      dispatch(
        increaseQuantity({
          orderItemID: id,
          size: size,
          type: "orderItem",
        })
      );
    };

  return (
    <Row className="my-3 mx-0 justify-content-between">
      <div
        onClick={() => {
          const quantity = orderItem?.quantity || 1;
          if (quantity > 1) {
            dispatch(
              decreaseQuantity({
                orderItemID: orderItem?.orderItemID,
                size: orderItem?.size,
                type: "orderItem",
              })
            );
          }
        }}
        style={{
          pointerEvents: orderItem?.quantity <= 1 ? "none" : "auto",
          marginRight: "0px",
          marginLeft:"0px",
        }}
        className="top_cards__operators d-flex justify-content-center align-items-center"
      >
        {" "}
        <FaMinus
          style={{
            color:
              orderItem?.quantity === 1
                ? "rgb(170, 170, 172)"
                : "rgb(82, 95, 127)",
          }}
        />{" "}
      </div>
      <div className="top_cards__number">{orderItem?.quantity || 1}</div>
      <div
        onClick={() => handleIncrement(orderItem?.orderItemID, orderItem?.size)}
        style={{
          border: `2px solid ${isDisabled ? "rgb(170, 170, 172)" : bgColor}`,
          color: bgColor,
          pointerEvents: isDisabled ? "none" : "auto",
          marginLeft: "0px",
          marginRight: "0px",
        }}
        className="top_cards__operators-active d-flex justify-content-center align-items-center"
      >
        <FaPlus
          style={{
            color: isDisabled ? "rgb(170, 170, 172)" : bgColor,
          }}
        />
      </div>
    </Row>
  );
};

export default ItemCounter;
